__webpack_require__.p = "/reports-time-based-metric/referrals-hub/";